// src/store/thunks/organizationUsers/updateUserThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { PortalUserValues, UserEntity } from '@/types/users.types';
import { withLoader, withErrorHandling } from '@/store/thunks/thunkWrappers';
import { normalizeEmail } from '@/utils/strings/strings';

interface UpdateUserArgs {
  id: string;
  data: PortalUserValues;
}

// Update an existing portal user
export const updateUserThunk = createAdminAsyncThunk<
  UserEntity, // return type: updated user entity
  UpdateUserArgs // args: id + data
>(
  'organizationUsers/update',
  withLoader(
    withErrorHandling(
      async({ id, data }, { extra: { usersService } }) =>
        await usersService.updateUser(id, { ...data, email: normalizeEmail(data.email) })
    )
  )
);
